import type { ToolId } from './types';

/**
 * Design-time constants shared across the core.
 *
 * The artwork "design box" is a fixed virtual coordinate system. All geometry
 * and stored points are expressed relative to it, then normalized to [0,1].
 * The renderer maps the normalized box onto whatever pixel size it wants.
 */
export const DESIGN = {
  /** Virtual design width/height (square). Geometry is authored in these units. */
  width: 1000,
  height: 1000,
} as const;

/** The four locked child-facing colors (spec). */
export const PALETTE = {
  red: '#e23b3b',
  yellow: '#f4c430',
  blue: '#2f6fed',
  turquoise: '#1fb6b6',
} as const;

export type PaletteKey = keyof typeof PALETTE;

export const DEFAULT_COLOR: string = PALETTE.red;
export const DEFAULT_TOOL: ToolId = 'marker';

/** Brush radius as a fraction of artwork width. Big enough for a 2–3 yo finger. */
export const MARKER_SIZE = 0.035;
export const ERASER_SIZE = 0.055;

/** Press-and-hold reset duration (ms) and the movement tolerance that cancels it. */
export const RESET_HOLD_MS = 2000;
/** If the finger moves more than this fraction of the min viewport dim, cancel hold. */
export const RESET_MOVE_TOLERANCE = 0.04;

/**
 * Max normalized distance between consecutive raw points before we interpolate
 * extra points. Prevents dotted/broken strokes during fast finger movement.
 */
export const INTERP_MAX_STEP = 0.006;
